import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../../../components/controls/FormGroup';
import { Field, reduxForm } from 'redux-form/immutable';
import { MuiInputText } from '../../../components/controls/MuiInputText';
import MuiButton from '../../../components/controls/MuiButton';
import ConfirmPassword from '../../../components/ConfirmPassword/ConfirmPassword';
import partnerManagerResources from './partnerManagerResources';
import { defaultFormProperties } from '../../../utilities/form';
import validate, * as partnerManagerValidation from './partnerManagerValidation';
import resources from '../../Shared/resources';

function ManagePartnerManagerForm({
    pristine,
    submitting,
    handleSubmit,
    isShowPasswordControls,
    onCancel
}) {
    return (
        <FormGroup onSubmit={handleSubmit}>
            <Field
                id="first_name"
                label={partnerManagerResources.labelFirstName}
                name="firstName"
                component={MuiInputText}
                validate={[
                    partnerManagerValidation.firstNameRequired,
                    partnerManagerValidation.firstNameMaxLength
                ]}
            />
            <Field
                id="last_name"
                label={partnerManagerResources.labelLastName}
                name="lastName"
                component={MuiInputText}
                validate={[
                    partnerManagerValidation.lastNameRequired,
                    partnerManagerValidation.lastNameMaxLength
                ]}
            />
            <Field
                id="email"
                label={partnerManagerResources.labelEmailAddress}
                name="email"
                component={MuiInputText}
                validate={[
                    partnerManagerValidation.emailAddressRequired,
                    partnerManagerValidation.emailAddressFormat,
                    partnerManagerValidation.emailAddressMaxLength
                ]}
            />
            {isShowPasswordControls ? <ConfirmPassword /> : <></>}
            <div className="grid__row">
                <div className="col-xs-12 col-md-3 col-lg-4">
                    <MuiButton
                        className="btn_new btn_new--blue"
                        size="medium"
                        type="submit"
                        disabled={pristine || submitting}
                    >
                        {resources.saveButtonText}
                    </MuiButton>
                </div>
                <div className="col-xs-12 col-md-3 col-lg-4">
                    {
                        onCancel && <MuiButton
                            className="btn_new btn_new--blue"
                            size="medium"
                            type="button"
                            onClick={onCancel}
                                    >
                            {resources.cancelButtonText}
                        </MuiButton>
                    }
                </div>
            </div>
        </FormGroup>
    );
}

ManagePartnerManagerForm.propTypes = {
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isShowPasswordControls: PropTypes.bool.isRequired,
    onCancel: PropTypes.func,
};

ManagePartnerManagerForm.defaultProps = {
    isShowPasswordControls: true
};

export default reduxForm({
    form: 'managePartnerManagerForm',
    validate,
    ...defaultFormProperties
})(ManagePartnerManagerForm);
